/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

/**
 * @module
 * @description
 * Entry point for all public APIs of the common/testing package.
 */
export {SpyLocation} from './location_mock';
export {MockLocationStrategy} from './mock_location_strategy';

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
